module.exports = __webpack_public_path__ + "static/media/gha_titanium_blank.55f45567.png";